import {Modal} from "flowbite-react";
import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {clearButtonProcessing, resetAlert, setAlertSuccess, setButtonProcessing} from "../../store/actions";
import {ErrorMessageAlert} from "../../components";
import {errorStatusHandle, getAlertErrorMessage, getFormErrorResponseData} from "../../utils";
import {createInspections} from "../../api/inspetionItemApi";
import InspectionForm from "./InspectionForm";
import {Button} from "../../components";

function ModalCreateInspection({ openModal, setOpenModal, modalData, setNewRow }) {
  const dispatch = useDispatch();
  const initialInputs = {
    template_id: modalData.template_id,
    inspection_item_type: "input",
    has_value_limit: "yes",
    upper_boundary_type: "1",
    lower_boundary_type: "1",
    has_unit: "true",
    input_value_type: "1",
  };
  const [inputs, setInputs] = useState(initialInputs);
  const [errorMessages, setErrorMessages] = useState({});

  // Function to handle closing modal
  const handleClose = () => {
    setInputs(initialInputs);
    setErrorMessages({});
    setOpenModal(false);
  };

  // Function to handle add new inspection item
  const createInspection = async (e, buttonId) => {
    e.preventDefault();
    dispatch(resetAlert());
    dispatch(setButtonProcessing(buttonId));
    await createInspections(inputs).then(
      (response) => {
        dispatch(setAlertSuccess(response.message));
        setNewRow(response.data.inspection_item)
        handleClose();
      }
    ).catch(e => {
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        let errorResponse = getFormErrorResponseData(e);
        if (errorResponse) {
          setErrorMessages(errorResponse);
        }
      }
    }).finally(() => {
      dispatch(clearButtonProcessing(buttonId));
    });
  };

  return (
    <Modal show={openModal} onClose={() => handleClose()} size="4xl">
      <Modal.Header>プロパティ</Modal.Header>
      <Modal.Body className="p-[20px] bg-[#F2F4F7]">

        <ErrorMessageAlert className="mb-[16px]" error={getAlertErrorMessage(errorMessages)} />
        <InspectionForm setInputs={setInputs} modalData={modalData} errorMessages={errorMessages} />

      </Modal.Body>
      <Modal.Footer className="space-x-[32px]">
        <div className="w-1/2">
          <Button color="light" className="w-full" onClick={() => handleClose()}>
            閉じる
          </Button>
        </div>
        <div className="w-1/2">
          <Button color="primary" className="w-full" onClick={(e) => createInspection(e, 'create-inspection-item')} id='create-inspection-item'>
            新規追加
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCreateInspection;